import React, { useEffect, useState } from "react";
import "../assets/css/advertising.css";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Button, Tabs, Tab, Box } from "@mui/material";
import { useHistory } from "react-router-dom";
import DropdownMenu from "../components/MyDropdown/MyDropdown";
import config from "../api/config";
import { useDispatch } from "react-redux";
import { setToast } from "../redux/actions/ToastAction";
import ImageUpload from "../components/ImageMultipleUpload/Attachment";
import CustomSelect from "../components/select";
import TextEditor from "../components/TextEditor";

import { htmlToMarkdown } from "../components/TextEditor/Parser";
// tabs
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// component start
const AddAd = () => {
  const { location } = useHistory();
  const data = location.data;
  // dispatch
  const dispatch = useDispatch();
  // navigator
  const navigate = useHistory();
  // id
  const [id, setId] = useState(data ? data.id : null);
  // error
  const [error, setError] = useState(false);
  // fields
  const [name, setName] = useState(data ? data.name : "");
  const [allTypes] = useState([{
  name: "GROUP",
  val: "GROUP"
}, {
  name: "TEST",
  val: "TEST"
}, {
  name: "USER",
  val: "USER"
}]);
  const [chatType, setChattype] = useState(
    data ? (data.category ? allTypes[0].val : allTypes[1].val) : allTypes[0].val
  );
  const [counts, setCounts] = useState(null);

  const [cats, setCats] = useState([]);
  const [currentCat, setCurrentCat] = useState(data ? data.category : null);

  const [uz, setUz] = useState(data ? data.descriptionUz : "");
  const [ru, setRu] = useState(data ? data.descriptionRu : "");
  const [en, setEn] = useState(data ? data.descriptionEn : "");

  const [imageView, setImageView] = useState(false);
  const [images, setImages] = useState([]);

  // tabs
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const textareas = [
    {
      placeholder: "Полное описание",
      value: ru,
      onChange: (e) => setRu(e),
    },
    {
      placeholder: "To'liq tavsif",
      value: uz,
      onChange: (e) => setUz(e),
    },
    {
      placeholder: "Full description",
      value: en,
      onChange: (e) => setEn(e),
    },
  ];

  // configuration for dropdown and counts
  useEffect(() => {
    config
      .get("/api/category/v1")
      .then((db) => {
        if (data) {

          if (Array.isArray(data.category) && data.category.length > 0)
            setCats([
              {
                nameRu: data.category[0].nameRu,
                children: db.data.objectKoinot,
              },
            ]);
          else {
            setCats([
              {
                nameRu: "Выбрать",
                children: db.data.objectKoinot,
              },
            ]);
          }
        } else setCats([{ nameRu: "Выбрать", children: db.data.objectKoinot }]);
      })
      .catch((err) => console.error(err?.message));
    // counts
    config
      .get("/api/statistics/v1/getCount")
      .then((data) => setCounts(data.data.objectKoinot));
    // if (data) setAllKeys(await getKeys(data.category[0].id));
    return () => {
      setCats([]);
    };
  }, [data]);

  // curr category changer
  const CatChanger = async (item) => {
    // setAllKeys([]);
    let category = {
      id: item.id,
      nameEn: item.nameEn,
      nameRu: item.nameRu,
      nameUz: item.nameUz,
    };
    setCurrentCat(category);
    let oldCats = [...cats];
    oldCats[0].nameRu = category.nameRu;
    setCats(oldCats);
    // const keyss = await getKeys(item.id);
    // setAllKeys(keyss);
  };
  // submit
  const handleSubmit = async () => {
    if (name !== "" && ru !== "") {
      let ad = {
        chatType: chatType,
        descriptionEn: htmlToMarkdown(en),
        descriptionRu: htmlToMarkdown(ru),
        descriptionUz: htmlToMarkdown(uz),
        name,
      };
      if (chatType === "GROUP" || chatType === "TEST")
        ad.categoryId = currentCat.id;

      if (data) {
        ad.id = data.id;
      }

      try {
        const res = await config.post("/api/advertising/v1/saveOrEdit", ad);
        // dispatch(setToast("true", "success", "Успешно опубликовано"));
        dispatch(
          setToast("true", "success", res.data?.message, res.data?.objectKoinot)
        );

        setImageView(true);
        setId(res.data.objectKoinot);
      } catch (err) {
        console.error(err?.message);
      }
    } else {
      setError(true);
    }
  };
  // submit imageList
  const handleSubmitImages = async () => {
    // create formData object
    const formData = new FormData();
    images.forEach((file) => {
      formData.append("files", file.file);
    });
    try {
      await config.post(
        `/koinot/attachment/v1/advertisingImage/${id}`,
        formData,
        {
          headers: {
            "content-type": "multipart/form-data",
          },
        }
      );
      dispatch(setToast(true, "success", "Успешно опубликовано"));
      navigate.push("/");
    } catch (err) {
      console.error(err?.message);
    }
  };
  return (
    <div className="advertising">
      {data ? (
        <Button
          onClick={() => navigate.push(`/`)}
          variant="outlined"
          startIcon={<ArrowBackIosNewIcon />}
          style={{
            padding: "12px 22px",
            borderRadius: "40px",
            fontWeight: "bold",
          }}
        >
          Отменить и назад
        </Button>
      ) : null}

      <div className="row">
        <div
          className={`col-lg-6 col-12 position-relative ${
            imageView ? "opacity-25" : ""
          }`}
        >
          {imageView ? <div className="hide"></div> : null}
          <label htmlFor="name">Введите название рекламы</label> <br />
          <input
            style={{
              borderColor: error && name === "" ? "var(--error-color" : "",
            }}
            id="name"
            type="text"
            placeholder=""
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <div className="d-flex justify-content-between align-items-top w-100 my-4">
            <div>
              <label>Введите тип рекламы</label> <br />
              <CustomSelect
                selVal={chatType}
                selItems={allTypes}
                type={"outlined"}
                selHandle={(e) => {
                  setChattype(e);

                }}
              />
              <p className="fw-bold my-3">
                Ваша реклама будет отправлена <br />
                <span style={{ color: "var(--second-color)" }}>
                  {" "}
                  {chatType === "GROUP" && `в ${counts?.countGroup} группы`}
                  {chatType === "USER" && `${counts?.userCount} пользователям`}
                  {chatType === "TEST" && `администратору`}
                </span>
              </p>
            </div>
            {chatType === "GROUP" || chatType === "TEST" ? (
              <div>
                <label htmlFor="">Категория</label> <br />
                {/* select */}
                <DropdownMenu
                  error={error && !currentCat.id}
                  selectedcat={currentCat}
                  config={cats}
                  _callback={(e) => CatChanger(e)}
                />
                {/* <Dropdown
                  customToggle={<RenderCats cat={currentCat} />}
                  small={true}
                  contentData={
                    <List
                      sx={{ width: "100%" }}
                      component="nav"
                      aria-labelledby="nested-list-subheader"
                    >
                      {cats.map((item, index) => (
                        <NestedDropdown
                          catId={currentCat?.id}
                          item={item}
                          clickHandler={CatChanger}
                        />
                      ))}
                    </List>
                  }
                /> */}
              </div>
            ) : null}
          </div>
          {/* description */}
          <label htmlFor="description">Полное описание</label> <br />
          <Box>
            <Box>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label="Oписание Ru"
                  style={{ color: "var(--txt-white)" }}
                  {...a11yProps(0)}
                />
                <Tab
                  label="Oписание Uz"
                  style={{ color: "var(--txt-white)" }}
                  {...a11yProps(1)}
                />
                <Tab
                  label="Oписание En"
                  style={{ color: "var(--txt-white)" }}
                  {...a11yProps(2)}
                />
              </Tabs>
            </Box>
            <br />

            {textareas.map((item, index) => {
              return (
                <TabPanel value={value} key={index} index={index}>
                  {/* <textarea
                    style={{
                      borderColor:
                        error && index == 0 && ru === ""
                          ? "var(--error-color)"
                          : "",
                    }}
                    onChange={(e) => item.onChange(e.target.value)}
                    placeholder={item.placeholder}
                    rows="10"
                    value={item.value}
                  ></textarea> */}
                  <TextEditor
                    placeholder={item.placeholder}
                    value={item.value}
                    onChange={(e) => {

                      item.onChange(e);
                    }}
                  />
                </TabPanel>
              );
            })}
          </Box>
          <br /> <br />
          {!imageView ? (
            <Button
              variant="contained"
              style={{
                background: "var(--second-color)",
                padding: "12px 40px",
                borderRadius: "40px",
                fontWeight: "bold",
              }}
              onClick={handleSubmit}
            >
              Сохранить
            </Button>
          ) : null}
        </div>
        <div className="col-lg-6 col-12">
          {imageView ? (
            <>
              <ImageUpload
                _callback={setImages}
                value={images}
                maxNumber={10}
              />

              {images.length > 0 ? (
                <Button
                  className="mt-4"
                  variant="contained"
                  style={{
                    background: "var(--second-color)",
                    padding: "12px 40px",
                    borderRadius: "40px",
                    fontWeight: "bold",
                  }}
                  onClick={handleSubmitImages}
                >
                  Сохранить изображения
                </Button>
              ) : null}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default AddAd;
